import React, { useState } from "react";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import PersonRemoveOutlinedIcon from "@mui/icons-material/PersonRemoveOutlined";
import { RowAction, RowMenu, StaticRole } from "./PermissionControl";

interface PendingAccessControlsProps {
  email: string;
  canRevokeAccess: boolean;
  onResend?: () => Promise<void>;
  onRevoke?: () => Promise<void>;
  onMenuToggle?: (isOpen: boolean) => void;
}

export const PendingAccessControls: React.FC<PendingAccessControlsProps> = ({
  email,
  canRevokeAccess,
  onResend,
  onRevoke,
  onMenuToggle,
}) => {
  const [isResending, setIsResending] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);
  const [isRevoking, setIsRevoking] = useState(false);

  const resend = async (send: () => Promise<void>) => {
    setIsResending(true);
    try {
      await send();
      setResendSuccess(true);
      setTimeout(() => setResendSuccess(false), 2000);
    } finally {
      setIsResending(false);
    }
  };

  const revoke = async (cancel: () => Promise<void>) => {
    setIsRevoking(true);
    try {
      await cancel();
    } finally {
      setIsRevoking(false);
    }
  };

  const actions: RowAction[] = [];
  if (onResend)
    actions.push({
      Icon: SendOutlinedIcon,
      label: "Resend Invitation",
      onClick: () => void resend(onResend),
    });
  if (canRevokeAccess && onRevoke)
    actions.push({
      Icon: PersonRemoveOutlinedIcon,
      label: "Cancel Invite",
      onClick: () => void revoke(onRevoke),
      destructive: true,
    });

  if (actions.length === 0) return <StaticRole label="Invited" tone="medium" />;

  return (
    <RowMenu
      label="Invited"
      ariaLabel={`Invited, actions for ${email}`}
      menuLabel={`Invitation for ${email}`}
      actions={actions}
      busy={isResending || isRevoking}
      success={resendSuccess}
      onMenuToggle={onMenuToggle}
    />
  );
};
